import S3PhotoModel from './S3PhotoModel';
import moment from 'moment';

export default class PatientModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.email = data.email || '';
    this.photo = data.photo ? new S3PhotoModel(data.photo) : null;
    this.last_appointment_time = data.last_appointment_time ? moment(data.last_appointment_time).toDate() : null;

    this.group_session_patient = data.group_session_patient || false;
    this.individual_session_patient = data.individual_session_patient || false;

    this.phone_number = data.phone_number || '';
    this.school = data.school || null; // id,name
  }

  get displayName() {
    if (this.first_name || this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    }
    return '';
  }

  get type() {
    if (this.group_session_patient && this.individual_session_patient) {
      return 'Group + Individual';
    }

    if (this.group_session_patient) {
      return 'Group';
    }

    return 'Individual';
  }
}
